var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 92,
    viewBox: "0 0 60 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.136 45.6l30.61-38.133L34.316.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M.136 27.2l41.32-23.39-7.14-3.754z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    x2: "100.001%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2BA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDA826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M27.175 3.81L.136 27.2 34.316.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M.136 32l27.04-23.39L28.537.655z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "0%",
    y1: "50.001%",
    y2: "50.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M.136 37.6L28.538 6.255l-5.78-5.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "0%",
    y1: "49.999%",
    y2: "49.999%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2BA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDA826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M3.926 7.464L34.536 45.6.356.229z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M.53 6.255L28.936 37.6 6.309.625z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: "0%",
    y1: "49.999%",
    y2: "49.999%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2BA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDA826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "M1.896 8.61L28.936 32 .53.655z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: "0%",
    y1: "50.001%",
    y2: "50.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M34.536 27.2L7.496 3.81.356.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M.411 3.81L41.736 27.2 7.556.056z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: ".001%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2BA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDA826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M5.914 5.698L.136 51.2 11.693.067z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: "-.001%",
    x2: "99.998%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2BA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDA826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "H",
    d: "M.136 41.6l7.14-37.548L.136.298z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: "-.001%",
    x2: "99.997%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F2BA38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDA826"
  })), /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "M12.136 51.2L6.358 5.698.579.068z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: ".001%",
    x2: "99.999%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M.192 4.052L7.336 41.6V.298z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: ".002%",
    x2: "99.999%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EDA826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6CA49"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 30.164 16.236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.136 45.6l30.61-38.133L34.316.23z",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE029",
    d: "M21.396 15.654l1.156 7.988 5.632-5.78 7.954 1.362-3.754-7.139 3.754-7.14-7.95 1.36L22.552.528l-1.156 7.986-7.239 3.571z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 39.364 7.036)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M.136 27.2l41.32-23.39-7.14-3.754z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 39.364 7.036)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M27.175 3.81L.136 27.2 34.316.056z",
    mask: "url(#i)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 36.964 9.436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M.136 32l27.04-23.39L28.537.655z",
    mask: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 34.164 12.236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M.136 37.6L28.538 6.255l-5.78-5.63z",
    mask: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 47.364 33.436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M3.926 7.464L34.536 45.6.356.229z",
    mask: "url(#r)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE029",
    d: "M21.392 84.017L22.552 92l5.632-5.778 7.954 1.367-3.754-7.146 3.754-7.14-7.954 1.366-5.631-5.778-1.161 7.982-7.234 3.57z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 48.564 26.636)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M.53 6.255L28.936 37.6 6.309.625z",
    mask: "url(#u)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 51.364 23.836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M1.896 8.61L28.936 32 .53.655z",
    mask: "url(#x)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 56.564 24.236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "A",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M34.536 27.2L7.496 3.81.356.056z",
    mask: "url(#A)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 60.164 27.836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M.411 3.81L41.736 27.2 7.556.056z",
    mask: "url(#D)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 27.364 19.036)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "G",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M5.914 5.698L.136 51.2 11.693.067z",
    mask: "url(#G)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 32.164 14.236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#H"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M.136 41.6l7.14-37.548L.136.298z",
    mask: "url(#J)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 33.364 25.036)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "M",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M12.136 51.2L6.358 5.698.579.068z",
    mask: "url(#M)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 35.764 17.836)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M.192 4.052L7.336 41.6V.298z",
    mask: "url(#P)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE029",
    d: "M0 46.264l7.234 3.57 1.161 7.987 5.631-5.778 7.954 1.365-3.753-7.144 3.753-7.14-7.954 1.362-5.63-5.779-1.162 7.988z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftStars);
export default __webpack_public_path__ + "static/media/left-stars.f353affa951744cfb96f8b63177e4add.svg";
export { ForwardRef as ReactComponent };